import React from "react";

import Link from "shared/components/Link";
import Str from "shared/components/Str";

import {
	selectedOptionOnNavBarEvent,
	selectedFirstPartyPromoEvent,
} from "routers/Desktop/NavBar/components/util/analytics";

import "./UpgradeLink.scss";

const UpgradeLink = () => {
	return (
		<Link
			to="/upgrade?cf=desktopnavbar"
			className="upgrade-link"
			onClick={() => {
				selectedOptionOnNavBarEvent("Alist");
				selectedFirstPartyPromoEvent("alist");
			}}
		>
			<Str className="upgrade-link-text">Join A-List</Str>
		</Link>
	);
};

export default UpgradeLink;



// WEBPACK FOOTER //
// ./src/routers/Desktop/NavBar/components/UpgradeLink/UpgradeLink.jsx